module.exports = __webpack_public_path__ + "img/iloranta_courier.c54facbb.svg";